<template>
  <div class="h-100">
    <div id="wrapper" class="col-md-10 mr-auto ml-auto" style="overflow:scroll;" :style="SHOW_TRIAGE_FORM ? 'height: 91%;' : ''">
      <!-- Patient details-->
      <transition enter-active-class="slideInRight">
        <card :noFooterLine="true" :class="{'h-100 mb-0':createPatientBtnFixed}" :footerClasses="{'create-button-fixed':createPatientBtnFixed,'pt-0':true}" headerClasses="pt-0">
          <div slot="header">
            <div class="row">
              <div class="col-8">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Patient Details") }}
                </h4>
                <small v-if="!PATIENT_SELECTED && !NEW_PATIENT && !SKIP_PATIENT && !SHOW_PATIENT_REGISTER_FORM">
                  <i>{{ $t("message.Search or create new patient") }}</i>
                </small>
              </div>
              <div class="col-4 text-right pt-2" v-if="(PATIENT_SELECTED || NEW_PATIENT || SKIP_PATIENT) && !$store.state.erEncounter">
                <i class="fa fa-times-circle fa-2x text-muted" style="font-weight: 100" @click="resetPatientSelection()"></i>
              </div>
            </div>
          </div>

          <!-- Patient search -->
          <div class="row h-100" v-if="!PATIENT_SELECTED && !NEW_PATIENT && !SKIP_PATIENT && !SHOW_PATIENT_REGISTER_FORM">
            <div class="col-12 h-100">
              <cool-select class="custom-input" :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :items=[] ref="select" disable-filtering-by-search :resetSearchOnBlur="false" @search="searchPatients" item-text="firstName" item-value="name" :search-text.sync="patientSearchText">
                <template slot="no-data">
                  <div v-show="patientSearchText && patientSearchText.length > 2 && patients.length<1">{{ $t("message.No patients found") }}</div>
                </template>
              </cool-select>
              <div style="align-items: center" class="patient-selection pl-3 pr-1" v-if="patientSearchText && patients.length>0">
                <div class="row" v-for="patient in patients" :key="patient._id" @click="selectPatient(patient)">
                  <div class="pr-1 col-11 autocomplete-result">
                    <div class="row">
                      <div class="col-2 pl-0 pr-0">
                        <profile-image :file-id="patient.profileImage" image-class="avatar border-gray" :image-style="'border-radius: 50%;width:50px;height: 50px; background-size: cover;'" v-if="patient.profileImage">
                        </profile-image>
                        <i class="fa fa-user-injured text-center" v-if="!patient.profileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 50px;height: 50px;font-size: large;"></i>
                      </div>
                      <div class="col-10">
                        <h6 class="item-name">
                          {{ patient.firstName }} {{ patient.lastName }}
                        </h6>
                        <div class="row">
                          <div class="col-3 pr-0">{{ getGender(patient.gender) }}</div>
                          <div class="col-8 pr-0">{{ getAge(patient.dob) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pl-0 col-1" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Create patient -->
          <div class="row" v-if="NEW_PATIENT && !PATIENT_SELECTED && !SKIP_PATIENT">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <fg-input type="text" :label="$t('message.First Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.First Name')" v-model="emergencyRoomEncounter.patient.firstName" name="firstName" v-validate="modelValidations.firstName" :error="getError('firstName')"></fg-input>
                </div>
                <div class="col-12">
                  <fg-input type="text" :label="$t('message.Last Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Last Name')" v-model="emergencyRoomEncounter.patient.lastName" name="lastName" v-validate="modelValidations.lastName" :error="getError('lastName')"></fg-input>
                </div>
                <div class="col-12 col-md-12 form-group">
                  <label for="" class="mb-0 pl-1">{{$t('message.Gender')}}</label>
                  <div style="display:flex;justify-content:left;">
                    <n-radio class="pr-2" v-model="emergencyRoomEncounter.patient.gender" label="male">{{$t('message.Male')}}</n-radio>
                    <n-radio class="pr-2" v-model="emergencyRoomEncounter.patient.gender" label="female">{{$t('message.Female')}}</n-radio>
                    <n-radio class="pr-2" v-model="emergencyRoomEncounter.patient.gender" label="others">{{$t('message.Others')}}</n-radio>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="row">
                    <div class="col-12 ">
                      <div style="position: relative;">
                        <fg-input name="age" type="number" :label="$t('message.Age')" labelClasses="float-input-label" v-model="patientAge" v-validate="modelValidations.age" :placeholder="$t('message.Age')" inputClasses="pb-1" :error="getError('age')">
                        </fg-input>

                        <div style="position: absolute; top: 0px; inset-inline-end: 0px; width:35%;" id="age-dropdown">
                          <el-select style="width: 100%;" class="form-group select-primary" size="large" name="latestStatus" placeholder="years" v-model="ageUnit">
                            <el-option class="select-primary" value="years" :label="$t('message.Years')"></el-option>
                            <el-option class="select-primary" value="months" :label="$t('message.Months')"></el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <VuePhoneNumberInput style="direction: ltr;" v-model="mobileNumber" :border-radius="25" default-country-code="IN" :preferred-countries="['IN']" @update="mobileNumberUpdate" />
                  <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="mobileNumber && !isValidMobile">
                    {{ $t("message.Please enter valid mobile number") }}
                  </div>
                  <fg-input class="hide-input" name="mobileNumber" v-model="mobileNumber"></fg-input>
                </div>
                <div class="col-12">
                  <fg-input :label="$t('message.Email')" labelClasses="float-input-label" inputClasses="pb-1" name="email" :placeholder="$t('message.Email')" v-model="emergencyRoomEncounter.patient.email" v-validate="modelValidations.email" :error="getError('email')"></fg-input>
                </div>

                <div class="col-12 form-group" style="position:relative;">
                  <label for="" v-if="emergencyRoomEncounter.patient && emergencyRoomEncounter.patient.history" class="float-input-label">{{$t('message.Medical history, allergies and ailments')}}</label>
                  <textarea :placeholder="$t('message.Medical history, allergies and ailments')" v-model="emergencyRoomEncounter.patient.history"></textarea>
                </div>

                <div class="col-12 text-center">
                  <n-button type="primary" round @click.native="validatePatientDetails()" v-if="PATIENT_SELECTED == false">
                    <h6 class="m-0">{{ $t("message.Next") }}</h6>
                  </n-button>
                  <check-mark-svg v-if="PATIENT_SELECTED == true"></check-mark-svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Register patient -->
          <div class="row" v-if="SHOW_PATIENT_REGISTER_FORM">
            <div class="col-12 h-100">
              <cool-select class="custom-input" :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :items=[] ref="select" disable-filtering-by-search :resetSearchOnBlur="false" @search="searchPatients" item-text="firstName" item-value="name" :search-text.sync="patientSearchText">
                <template slot="no-data">
                  <div v-show="patientSearchText && patientSearchText.length > 2 && patients.length<1">{{ $t("message.No patients found") }}</div>
                </template>
              </cool-select>
              <div style="align-items: center" class="patient-selection pl-3 pr-1" v-if="patientSearchText && patients.length>0">
                <div class="row" v-for="patient in patients" :key="patient._id" @click="updateRegisteredPatient(patient)">
                  <div class="pr-1 col-11 autocomplete-result">
                    <div class="row">
                      <div class="col-2 pl-0 pr-0">
                        <profile-image :file-id="patient.profileImage" image-class="avatar border-gray" :image-style="'border-radius: 50%;width:50px;height: 50px; background-size: cover;'" v-if="patient.profileImage">
                        </profile-image>
                        <i class="fa fa-user-injured text-center" v-if="!patient.profileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 50px;height: 50px;font-size: large;"></i>
                      </div>
                      <div class="col-10">
                        <h6 class="item-name">
                          {{ patient.firstName }} {{ patient.lastName }}
                        </h6>
                        <div class="row">
                          <div class="col-3 pr-0">{{ getGender(patient.gender) }}</div>
                          <div class="col-8 pr-0">{{ getAge(patient.dob) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pl-0 col-1" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <h6 style="margin-bottom: 15px;margin-top: 15px;">{{ $t("message.OR") }}</h6>
            </div>

            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <fg-input type="text" :label="$t('message.First Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.First Name')" v-model="patientRegistration.firstName" name="firstName" v-validate="modelValidations.firstName" :error="getError('firstName')"></fg-input>
                </div>
                <div class="col-12">
                  <fg-input type="text" :label="$t('message.Last Name')" labelClasses="float-input-label" inputClasses="pb-1" :placeholder="$t('message.Last Name')" v-model="patientRegistration.lastName" name="lastName" v-validate="modelValidations.lastName" :error="getError('lastName')"></fg-input>
                </div>
                <div class="col-12 col-md-12 form-group">
                  <label for="" class="mb-0 pl-1">{{$t('message.Gender')}}</label>
                  <div style="display:flex;justify-content:left;">
                    <n-radio class="pr-2" v-model="patientRegistration.gender" label="male">{{$t('message.Male')}}</n-radio>
                    <n-radio class="pr-2" v-model="patientRegistration.gender" label="female">{{$t('message.Female')}}</n-radio>
                    <n-radio class="pr-2" v-model="patientRegistration.gender" label="others">{{$t('message.Others')}}</n-radio>
                  </div>
                </div>
                <div class="col-12 col-md-12">
                  <div class="row">
                    <div class="col-12 ">
                      <div style="position: relative;">
                        <fg-input name="age" type="number" :label="$t('message.Age')" labelClasses="float-input-label" v-model="patientAge" v-validate="modelValidations.age" :placeholder="$t('message.Age')" inputClasses="pb-1" :error="getError('age')">
                        </fg-input>

                        <div style="position: absolute; bottom: 0px; inset-inline-end: 0px; width:35%; margin-bottom:-10px;" id="age-dropdown">
                          <el-select style="width: 100%;" class="form-group select-primary" size="large" name="latestStatus" placeholder="years" v-model="ageUnit">
                            <el-option class="select-primary" value="years" :label="$t('message.Years')"></el-option>
                            <el-option class="select-primary" value="months" :label="$t('message.Months')"></el-option>
                          </el-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <VuePhoneNumberInput style="direction: ltr;" v-model="mobileNumber" :border-radius="25" default-country-code="IN" :preferred-countries="['IN']" @update="mobileNumberUpdate" />
                  <div class="text-danger invalid-feedback mt-2" style="display: block" v-if="mobileNumber && !isValidMobile">
                    {{ $t("message.Please enter valid mobile number") }}
                  </div>
                  <fg-input class="hide-input" name="mobileNumber" v-model="mobileNumber"></fg-input>
                </div>
                <div class="col-12">
                  <fg-input :label="$t('message.Email')" labelClasses="float-input-label" inputClasses="pb-1" name="email" :placeholder="$t('message.Email')" v-model="patientRegistration.email" v-validate="modelValidations.email" :error="getError('email')"></fg-input>
                </div>

                <div class="col-12 form-group" style="position:relative;">
                  <label for="" v-if="patientRegistration && patientRegistration.history" class="float-input-label">{{$t('message.Medical history, allergies and ailments')}}</label>
                  <textarea :placeholder="$t('message.Medical history, allergies and ailments')" v-model="patientRegistration.history"></textarea>
                </div>

                <div class="col-12 text-center">
                  <n-button type="primary" simple round @click.native="SHOW_PATIENT_REGISTER_FORM = false; PATIENT_SELECTED = true;">
                    <h6 class=" m-0">Cancel</h6>
                  </n-button>
                  <n-button type="primary" round @click.native="registerPatient">
                    <h6 class="m-0">Register</h6>
                  </n-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Patient details-->
          <div class="row" v-if="PATIENT_SELECTED">
            <div class="col-3 pl-1 pr-0">
              <profile-image :file-id="patientProfileImage" image-class="avatar border-gray" :image-style="'border-radius: 50%;width:80px;height: 80px; background-size: cover; margin: auto'" v-if="patientProfileImage">
              </profile-image>
              <i class="fa fa-user-injured text-center" v-if="!patientProfileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 80px;height: 80px;font-size: 3em;"></i>
            </div>
            <div class="col-9 pl-1">
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{ emergencyRoomEncounter.patient.firstName }}
                    {{ emergencyRoomEncounter.patient.lastName }}</span>
                </div>
              </div>
              <div class="row" v-if="emergencyRoomEncounter.patient.patientId">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
                <div class="col-md-10 col-9 pl-0">
                  <span>{{emergencyRoomEncounter.patient.patientId}}</span>
                </div>
              </div>
              <div class="row" v-if="emergencyRoomEncounter.patient.mobileNumber">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-mobile"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{emergencyRoomEncounter.patient.mobileNumber}}</span>
                </div>
              </div>
              <div class="row" v-if="emergencyRoomEncounter.patient.email">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-envelope"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{emergencyRoomEncounter.patient.email}}</span>
                </div>
              </div>
              <div class="row" v-if="emergencyRoomEncounter.patient.history">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fas fa-history"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{emergencyRoomEncounter.patient.history}}</span>
                </div>
              </div>
            </div>
            <div class="col-12 text-center" v-if="isPatientUnregistered(emergencyRoomEncounter.patient) && $store.state.erEncounter">
              <n-button type="primary" class="mt-4" simple round @click.native="initiatePatientRegistration">
                <h6 class="m-0">Register</h6>
              </n-button>
            </div>
            <div v-else class="col-12 text-center">
              <check-mark-svg></check-mark-svg>
            </div>
          </div>

          <div slot="footer" class="col-12 text-center" v-if="!PATIENT_SELECTED && !NEW_PATIENT && !SKIP_PATIENT && !SHOW_PATIENT_REGISTER_FORM">
            <h6 style="margin-bottom: 15px;" v-if="settings && settings.idCardScanner && settings.idCardScanner.enabled">{{ $t("message.OR") }}</h6>
            <n-button type="primary" v-if="settings && settings.idCardScanner && settings.idCardScanner.enabled" round @click.native="openCameraModal">
              <h6 class="m-0"><i class="fa fa-camera" style="font-size: 1.3em;padding-right: 0.2em;"></i> Scan id card</h6>
            </n-button>
            <h6 style="margin-bottom: 15px;margin-top: 15px;">{{ $t("message.OR") }}</h6>
            <!-- added top margin for when buttons are side by side -->
            <n-button class="mt-4" type="primary" round @click.native="NEW_PATIENT = true">
              <h6 class="m-0"><i class="fa fa-plus" style="font-size: 1.3em;padding-right: 0.2em;"></i> {{ $t("message.Create new patient") }}</h6>
            </n-button>

            <!-- skip patient selection  -->
            <!-- added a gap between create and skip buttons -->
            <n-button type="primary" class="mt-4" simple round @click.native="skipPatientSelection" style="margin-left: 10px;">
              <h6 class="m-0">skip</h6>
            </n-button>
          </div>
        </card>
      </transition>

      <modal :show.sync="SHOW_CC" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white">
        <h6 slot="header" class="title title-up" style="margin-bottom: 1em;">Vitals</h6>
        <div class="col-12" style="height: 92%;overflow: scroll;padding: 0px;">
          <div class="col-12">
            <label for="">Initial VS at</label>
            <vue-datetime v-model="emergencyRoomEncounter.vitals.time" type="datetime" format="dd-MM-yyyy, hh:mm a" :placeholder="$t('message.Select Time')" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control mb-2"></vue-datetime>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-8">
                <fg-input type="number" label="Temp" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Temperature" v-model="emergencyRoomEncounter.vitals.temperature" name="temperature">
                </fg-input>
                <span style="position: absolute;top: 0px;right: 0px;">F</span>
              </div>
              <div class="col-4"></div>

              <div class="col-4">
                <fg-input type="number" label="BP Sys" labelClasses="float-input-label" inputClasses="pb-1" placeholder="BP Sys" v-model="emergencyRoomEncounter.vitals.bpSystolic" name="bp"></fg-input>
              </div>
              <div style="display: flex;align-items: center;">
                /
              </div>
              <div class="col-4">
                <fg-input type="number" label="BP Dia" labelClasses="float-input-label" inputClasses="pb-1" placeholder="BP Dia" v-model="emergencyRoomEncounter.vitals.bpDiastolic" name="bpDiastolic"></fg-input>
                <span style="position: absolute;top: 0px;right: -3rem;">mmHg</span>
              </div>

              <div class="col-8">
                <fg-input type="number" label="Pulse" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Pulse" v-model="emergencyRoomEncounter.vitals.pulse" name="pulse"></fg-input>
                <span style="position: absolute;top: 0px;right: -2rem;">bpm</span>
              </div>

              <div class="col-8">
                <fg-input type="number" label="SpO2" labelClasses="float-input-label" inputClasses="pb-1" placeholder="SpO2" v-model="emergencyRoomEncounter.vitals.spo2" name="spo2"></fg-input>
                <span style="position: absolute;top: 0px;right: 0px;">%</span>
              </div>

              <div class="col-8">
                <fg-input type="number" label="RR" labelClasses="float-input-label" inputClasses="pb-1" placeholder="RR" v-model="emergencyRoomEncounter.vitals.rr" name="rr"></fg-input>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" style="text-align:center;">
          <n-button type="primary" round size="md" @click.native="save">
            Save
          </n-button>
        </div>
      </modal>

      <modal :show.sync="SHOW_TRIAGE_ASSESSMENT" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white">
        <h6 slot="header" class="title title-up" style="margin-bottom: 1em;">Treating Provider Assessment</h6>
        <div style="height: 90vh;overflow: hidden scroll;">

          <div class="col-12" style="height: 92%;overflow: scroll;padding: 0px;">
            <div class="row">

              <div class="col-12">

                <vue-datetime v-model="emergencyRoomEncounter.treatingProviderAssessment.dateAndTime" type="datetime" format="dd-MM-yyyy, hh:mm a" placeholder="Select Date and Time" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control mb-2"></vue-datetime>

                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.deadOnArrival" class="mb-2">Dead on arrival</n-checkbox>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-12">
                <h6>High Risk Signs</h6>

                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.abnormalAVPU">Abnormal AVPU</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.hrInRange">{{'HR < 55 or > 130'}} (adult)</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.temperatureInRange">{{'Temp > 39 ̊C or < 36 ̊C'}}</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.spo2InRange">{{'SpO2 < 90% or RA'}}</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.stridor">Stridor, voice change or unable to swallow</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.respiratoryDistress">Respiratory distress (grunting in child, retractions, cyanosis)</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.poorPerfusion">Poor perfusion, weak pulse, capillary refill >3s</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.highRiskSigns.vomitsEverything">Vomits everything, can’t drink or feed</n-checkbox>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <h6>Primary Survey</h6>

                <div class="row" style="border: 1px solid grey;">
                  <div class="col-12 text-center" style="border-bottom: 1px solid grey;display: flex;justify-content: center;">
                    <div>
                      <span style="font-size: 2.5rem">A</span>
                      <span style="font-size: 0.8rem">irway</span>
                      <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.normal" class="mb-2 mt-0">NML</n-checkbox>
                    </div>
                  </div>
                  <div class="col-6" style="border-right: 1px solid grey;">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.angioedema" class="mb-2">Angioedema</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.stridor" class="mb-2">Stridor</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.voiceChanges" class="mb-2">Voice changes</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.oralBurns" class="mb-4">Oral/Airway burns</n-checkbox>

                    <h6>Obstructed by</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.tongue" class="mb-2">Tongue</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.blood" class="mb-2">Blood</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.secretions" class="mb-2">Secretions</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.vomit" class="mb-2">Vomit</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.foreignBody" class="mb-2">Foreign body</n-checkbox>
                  </div>
                  <div class="col-6">

                    <h6>Airway</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.repositioning" class="mb-2">Repositioning</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.suction" class="mb-2">Suction</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.OPA" class="mb-2">OPA</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.NPA" class="mb-2">NPA</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.LMA" class="mb-2">LMA</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.BVM" class="mb-2">BVM</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.airWay.ETT" class="mb-2">ETT</n-checkbox>
                  </div>
                </div>

                <div class="row" style="border: 1px solid grey;">
                  <div class="col-12 text-center" style="border-bottom: 1px solid grey;display: flex;justify-content: center;">
                    <div>
                      <span style="font-size: 2.5rem">B</span>
                      <span style="font-size: 0.8rem">reathing</span>
                      <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathingNormal" class="mb-2 mt-0">NML</n-checkbox>
                    </div>
                  </div>
                  <div class="col-6" style="border-right: 1px solid grey;">
                    <fg-input type="text" label="Spontaneous Respiratory Rate" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Spontaneous Respiratory Rate" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.spontaneousRespiratoryRate" name="spontaneousRespiratoryRate"></fg-input>

                    <h6>Chest Rise</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.shallow" class="mb-2">Shallow</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.retractions" class="mb-2">Retractions</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.paradoxical" class="mb-4">Paradoxical</n-checkbox>

                    <h6>Trachea</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.midline" class="mb-2">Midline</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.deviatedToL" class="mb-2">Deviated to L</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.deviatedToR" class="mb-2">Deviated to R</n-checkbox>

                    <h6>Breath Sounds</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.breathSoundsL" class="mb-2">L</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.breathSoundsR" class="mb-2">R</n-checkbox>
                  </div>
                  <div class="col-6">
                    <div class="row">
                      <div class="col-12" style="border-bottom: 1px solid grey;">
                        <h6>Oxygen</h6>

                        <div style="position: relative">
                          <div style="width :90%">
                            <fg-input type="number" label="Oxygen" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Oxygen" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.oxygnQuant" name="oxygnQuant">
                            </fg-input>
                          </div>
                          <span style="position: absolute;top: 0px;right: 0px;">L</span>
                        </div>

                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.NC" class="mb-2">NC</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.mask" class="mb-2">Mask</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.NRB" class="mb-2">NRB</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.BVM" class="mb-2">BVM</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.CPAP_OR_BIPAP" class="mb-2">CPAP/BIPAP</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.ventilator" class="mb-2">Ventilator</n-checkbox>
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.bronchodilator" class="mb-2">Bronchodilator</n-checkbox>
                      </div>
                      <div class="col-12">
                        <h6>Chest needle or tube</h6>

                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleL" class="mb-2">L</n-checkbox>
                        <fg-input type="number" label="Size" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleLsize" name="size"></fg-input>
                        <fg-input type="number" label="Depth(cm)" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Depth(cm)" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleLDepth" name="firstName"></fg-input>

                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleR" class="mb-2">R</n-checkbox>
                        <fg-input type="number" label="Size" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleRSize" name="firstName"></fg-input>
                        <fg-input type="number" label="Depth(cm)" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Depth(cm)" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.chestNeedleRDepth" name="firstName"></fg-input>

                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.breathing.threeSidedDressing" class="mb-2">3- sided dressing</n-checkbox>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" style="border: 1px solid grey;">
                  <div class="col-12 text-center" style="border-bottom: 1px solid grey;display: flex;justify-content: center;">
                    <div>
                      <span style="font-size: 2.5rem">C</span>
                      <span style="font-size: 0.8rem">irculation</span>
                      <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulationNormal" class="mb-2 mt-0">NML</n-checkbox>
                    </div>
                  </div>
                  <div class="col-6" style="border-right: 1px solid grey;">
                    <h6>Skin</h6>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.warm" class="mb-2">Warm</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.dry" class="mb-2">Dry</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.pale" class="mb-2">Pale</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.cyanotic" class="mb-4">Cyanotic</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.moist" class="mb-4">Moist</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.cool" class="mb-4">Cool</n-checkbox>

                    <h6>Capillary refill</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.capilaryRefillBelowThree" class="mb-2">
                      {{'< 3 sec or'}}</n-checkbox>
                    <fg-input type="number" label="Seconds" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Seconds" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.capilaryRefillTime" name="capilaryRefillTime"></fg-input>

                    <h6>Pulses</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.weakPulse" class="mb-2">Weak</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.asymetricPulse" class="mb-2">Asymmetric</n-checkbox>

                    <h6>JVD</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.jvd" class="mb-2">Yes</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.jvdFalse" class="mb-2">No</n-checkbox>
                  </div>
                  <div class="col-6">
                    <h6>Access</h6>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IV" class="mb-2">IV</n-checkbox>
                    <fg-input type="number" label="Loc" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Loc" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IVLoc" name="firstName"></fg-input>
                    <fg-input type="number" label="Size" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IVSize" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.CVL" class="mb-2">CVL</n-checkbox>
                    <fg-input type="number" label="Loc" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Loc" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.CLVLoc" name="firstName"></fg-input>
                    <fg-input type="number" label="Size" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.CLVSize" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IO" class="mb-2">IO</n-checkbox>
                    <fg-input type="number" label="Loc" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Loc" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IOLoc" name="firstName"></fg-input>
                    <fg-input type="number" label="Size" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IOSize" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IVF" class="mb-2">IVF</n-checkbox>
                    <fg-input type="number" label="mLs" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="mLs" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.IVFmls" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.NS" class="mb-2">NS</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.LR" class="mb-2">LR</n-checkbox>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.other" class="mb-2">Other</n-checkbox>
                    <fg-input type="number" label="Other" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Other" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.otherDetails" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.bloodOrdered" class="mb-2">Blood ordered</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.circulation.epinephrineGiven" class="mb-2">Epinephrine given</n-checkbox>
                  </div>
                </div>

                <div class="row" style="border: 1px solid grey;">
                  <div class="col-12 text-center" style="border-bottom: 1px solid grey;display: flex;justify-content: center;">
                    <div>
                      <span style="font-size: 2.5rem">D</span>
                      <span style="font-size: 0.8rem">isability</span>
                      <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disabilityNormal" class="mb-2 mt-0">NML</n-checkbox>
                    </div>
                  </div>
                  <div class="col-6" style="border-right: 1px solid grey;">
                    <div class="row">
                      <div class="col-6">
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.A" class="mb-2">A</n-checkbox>
                      </div>
                      <div class="col-6">
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.V" class="mb-2">V</n-checkbox>
                      </div>
                      <div class="col-6">
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.P" class="mb-2">P</n-checkbox>
                      </div>
                      <div class="col-6">
                        <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.U" class="mb-4">U</n-checkbox>
                      </div>
                    </div>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.movesAllExtremities" class="mb-2">Moves all extremities or</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.deflict" class="mb-2">Deficit</n-checkbox>
                    <fg-input type="number" label="Deficit" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Deficit" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.deflict_val" name="deflict_val"></fg-input>

                    <h6>Pupils</h6>

                    <fg-input type="number" label="Size L" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size L" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.pupilSizeL" name="pupilSizeL"></fg-input>
                    <fg-input type="number" label="Size R" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Size R" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.pupilSizeR" name="firstName"></fg-input>

                    <fg-input type="number" label="Reactivity L" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Reactivity L" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.pupilReactivityL" name="firstName"></fg-input>
                    <fg-input type="number" label="Reactivity R" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Reactivity R" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.pupilReactivityR" name="firstName"></fg-input>

                  </div>
                  <div class="col-6">

                    <h6>Blood Glucose</h6>

                    <fg-input type="number" label="Blood Glucose" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Blood Glucose" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.bloodGlucoseVal" name="firstName"></fg-input>

                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.glucose" class="mb-2">Glucose</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.naloxone" class="mb-2">Naloxone</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.antiepileptic" class="mb-2">Antiepileptic</n-checkbox>
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.OTHERS" class="mb-2">Others</n-checkbox>
                    <fg-input type="text" label="Others" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Others" v-model="emergencyRoomEncounter.treatingProviderAssessment.primarySurvey.disability.otherDetails" name="ohterGlucoseDetails"></fg-input>

                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-12">
                <h6>History of present illness</h6>

                <small>
                  <i>(Symptoms, time course, exacerbating and alleviating factors, prior episodes & prior interventions, including any primary health care)</i>
                </small>

                <textarea class="form-control" placeholder="Mention history and symptoms here" rows="3" v-model="emergencyRoomEncounter.treatingProviderAssessment.historyOfIlness"></textarea>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-12">
                <div style="display:flex;justify-content: space-between;width:100%;align-items: center">
                  <h6>Review of Systems</h6>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.generalNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="General" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="General" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.general" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.HEENTNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="HEENT" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="HEENT" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.HEENT" name="HEENT"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.respNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Resp" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Resp" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.resp" name="resp"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.CVNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="CV" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="CV" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.CV" name="cv"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.GINormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="GI" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="GI" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.GI" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.pelvisNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Pelvis/GU/Rectal" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Pelvis/GU/Rectal" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.pelvis" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.reproductiveNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Reproductive" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Reproductive" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.reproductive" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.skinNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Skin" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Skin" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.skin" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.mskNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="MSK" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="MSK" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.msk" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.neuroNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Neuro" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Neuro" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.neuro" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.hemeNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Heme" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Heme" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.heme" name="firstName"></fg-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-3">
                    <n-checkbox v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.psychiatricNormal" class="mb-2">NML</n-checkbox>
                  </div>
                  <div class="col-9">
                    <fg-input type="text" label="Psychiatric" labelClasses="float-input-label" inputClasses="pb-1 mt-1" placeholder="Psychiatric" v-model="emergencyRoomEncounter.treatingProviderAssessment.reviewOfSystems.psychiatric" name="firstName"></fg-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12" style="text-align:center;">
            <n-button type="primary" round size="md" @click.native="save">
              Save
            </n-button>
          </div>
        </div>
      </modal>

      <modal :show.sync="SHOW_TRIAGE_FORM_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white">
        <h6 slot="header" class="title title-up" style="margin-bottom: 1em;">Quick Triage</h6>
        <div style="height: 90vh;overflow: hidden scroll;">
          <div class="col-12" style="height: 92%;overflow: scroll;padding: 0px;">
            <div class="row">

              <div class="col-12">
                <h6>Contact Person</h6>

                <fg-input type="text" label="Name" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Name" v-model="emergencyRoomEncounter.contactPerson.name" name="name"></fg-input>
              </div>

              <div class="col-12">
                <fg-input type="number" label="Phone" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Phone" v-model="emergencyRoomEncounter.contactPerson.phoneNumber" name="phoneNumber"></fg-input>
              </div>

              <div class="col-12">
                <fg-input type="text" label="Relation" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Relation" v-model="emergencyRoomEncounter.contactPerson.relation" name="relation"></fg-input>
              </div>
              <div class="col-6"></div>
            </div>

            <div class="row mt-3">

              <div class="col-12">
                <h6>Arrival Information</h6>

                <vue-datetime v-model="emergencyRoomEncounter.arrivalInfo.date" type="datetime" format="dd-MM-yyyy, hh:mm a" placeholder="Arrival Date and Time" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control mb-2"></vue-datetime>
              </div>

              <div class="col-12">
                <label>Arrival Mode</label>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.ambulance">Ambulance</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.car">Car/Truck</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.bike">Motorized 2/3 Wheeler</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.publicTransport">Public Transport</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.walk">Walk</n-checkbox>
                <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.other">Other</n-checkbox>
              </div>

              <div class="col-12 mt-2">
                <fg-input type="number" label="Number of prior facilities" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Number of prior facilities" v-model="emergencyRoomEncounter.arrivalInfo.priorFacilities" name="priorFacilities"></fg-input>

              </div>

              <div class="col-12">
                <fg-input type="text" label="Referred from" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Referred from" v-model="emergencyRoomEncounter.arrivalInfo.referedFrom" name="referedFrom"></fg-input>
              </div>
              <div class="col-6"></div>
            </div>

            <label for="">Pain Score</label>
            <div class="row">
              <div class="col-12">
                <div class="d-flex" style="width: 100%;justify-content: space-between;">
                  <div>😀</div>
                  <div>🙂</div>
                  <div>😕</div>
                  <div>🙁</div>
                  <div>😟</div>
                  <div>😞</div>
                </div>
                <input type="range" min="0" max="10" step="1" v-model="emergencyRoomEncounter.triageCategory.painScore" style="width: 100%" class="mt-2">
                <div class="d-flex" style="width: 100%;justify-content: space-between;">
                  <div>
                    <small>No pain
                    </small>
                  </div>
                  <div>
                    <small>Moderate pain
                    </small>
                  </div>
                  <div>
                    <small>Worst pain
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <label for="" class="mt-3">Chief Complaint</label>
            <div class="row">
              <div class="col-12">
                <textarea class="form-control" placeholder="Enter chief complaint" rows="3" v-model="emergencyRoomEncounter.chiefComplaint"></textarea>
              </div>
            </div>
          </div>
          <div class="col-12" style="text-align:center;">
            <n-button type="primary" round size="md" @click.native="save">
              Save
            </n-button>
          </div>
        </div>
      </modal>

      <modal :show.sync="SHOW_CONSENTS" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white">
        <h6 slot="header" class="title title-up" style="margin-bottom: 1em;">Informed Consents</h6>
        <div class="consents-dropdown" v-if="consents && consents.length > 0">
          <drop-down :title="selectedConsent.name" tag="li" position="right" class="nav-item">
            <a class="dropdown-item" style="color:var(--color-primary)" @click="selectedConsent=consent" v-for="consent in consents" :key="consent._id">{{consent.name}}</a>
          </drop-down>
        </div>
        <div style="height: 83vh;overflow: hidden scroll;margin-top:1em" v-if="consents && consents.length > 0 && selectedConsent">
          <p id="informed-consent" v-html="selectedConsent.html"></p>

          <p v-if="!isConsentSigned">Signature</p>
          <vue-signature v-if="!isConsentSigned" ref="signature" style="border: solid;" :sigOption="signaturePadOptions" :w="'225px'" :h="'140px'" :disabled="signaturePadDisabled"></vue-signature>

          <div class="col-12 text-center" v-if="!isConsentSigned">
            <n-button type="primary" simple round @click.native="$refs.signature.clear()">
              <h6 class="m-0">
                {{ $t("message.Clear") }}
              </h6>
            </n-button>
            <n-button type="primary" round @click.native="agreeConsent">
              <h6 class="m-0">{{ $t("message.Agree") }}</h6>
            </n-button>
          </div>

          <div class="col-12 text-center" v-if="isConsentSigned">
            <n-button type="primary" round @click.native="viewFile()"><i class="fas fa-cloud-download-alt"></i> Download</n-button>
            <check-mark-svg></check-mark-svg>
          </div>
        </div>
        <div v-else class="col-12" style="text-align:center">
          No informed consents found
        </div>
      </modal>

      <!-- triaging form -->
      <transition v-if="SHOW_TRIAGE_FORM && !$store.state.erEncounter">
        <card :noFooterLine="true" headerClasses="pt-0">
          <div slot="header">
            <div class="row">
              <div class="col-12">
                <h4 slot="header" class="card-title">
                  Quick Triage
                </h4>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-12 pb-5">
              <h6>Triage Level</h6>

              <div class="col-12">
                <div class="d-flex" style="width: 100%;justify-content: space-between;align-items: end">
                  <div>
                    <h6 class="mb-0">5</h6>
                  </div>
                  <div>
                    <h6 class="mb-0">4</h6>
                  </div>
                  <div>
                    <h6 class="mb-0">3</h6>
                  </div>
                  <div>
                    <h6 class="mb-0">2</h6>
                  </div>
                  <div>
                    <h6 class="mb-0">1</h6>
                  </div>
                </div>
                <input type="range" min="-5" max="-1" step="1" v-model="severity" style="width: 100%" class="mt-2">
                <div class="d-flex" style="width: 100%;justify-content: space-between;">
                  <div>
                    <small>Low
                    </small>
                  </div>
                  <div>
                    <small>Moderate
                    </small>
                  </div>
                  <div>
                    <small>High
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-12">
              <h6>Contact Person</h6>

              <fg-input type="text" label="Name" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Name" v-model="emergencyRoomEncounter.contactPerson.name" name="name"></fg-input>
            </div>

            <div class="col-12">
              <fg-input type="number" label="Phone" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Phone" v-model="emergencyRoomEncounter.contactPerson.phoneNumber" name="phoneNumber"></fg-input>
            </div>

            <div class="col-12">
              <fg-input type="text" label="Relation" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Relation" v-model="emergencyRoomEncounter.contactPerson.relation" name="relation"></fg-input>
            </div>
            <div class="col-6"></div>
          </div>

          <div class="row mt-3">

            <div class="col-12">
              <h6>Arrival Information</h6>

              <vue-datetime v-model="emergencyRoomEncounter.arrivalInfo.date" type="datetime" format="dd-MM-yyyy, hh:mm a" placeholder="Arrival Date and Time" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control mb-2"></vue-datetime>
            </div>

            <div class="col-12">
              <label>Arrival Mode</label>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.ambulance">Ambulance</n-checkbox>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.car">Car/Truck</n-checkbox>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.bike">Motorized 2/3 Wheeler</n-checkbox>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.publicTransport">Public Transport</n-checkbox>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.walk">Walk</n-checkbox>
              <n-checkbox v-model="emergencyRoomEncounter.arrivalInfo.arrivalMode.other">Other</n-checkbox>
            </div>

            <div class="col-12 mt-2">
              <fg-input type="number" label="Number of prior facilities" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Number of prior facilities" v-model="emergencyRoomEncounter.arrivalInfo.priorFacilities" name="priorFacilities"></fg-input>

            </div>

            <div class="col-12">
              <fg-input type="text" label="Referred from" labelClasses="float-input-label" inputClasses="pb-1" placeholder="Referred from" v-model="emergencyRoomEncounter.arrivalInfo.referedFrom" name="referedFrom"></fg-input>
            </div>
            <div class="col-6"></div>
          </div>

          <label for="">Pain Score</label>
          <div class="row">
            <div class="col-12">
              <div class="d-flex" style="width: 100%;justify-content: space-between;">
                <div>😀</div>
                <div>🙂</div>
                <div>😕</div>
                <div>🙁</div>
                <div>😟</div>
                <div>😞</div>
              </div>
              <input type="range" min="0" max="10" step="1" v-model="emergencyRoomEncounter.triageCategory.painScore" style="width: 100%" class="mt-2">
              <div class="d-flex" style="width: 100%;justify-content: space-between;">
                <div>
                  <small>No pain
                  </small>
                </div>
                <div>
                  <small>Moderate pain
                  </small>
                </div>
                <div>
                  <small>Worst pain
                  </small>
                </div>
              </div>
            </div>
          </div>

        </card>
      </transition>

      <card :noFooterLine="true" class="triaging-tiles" v-if="$store.state.erEncounter">
        <div class="col-12" style="padding: 0px;text-align: center;">
          <n-button type="primary" simple round @click.native="SHOW_TRIAGE_FORM_MODAL=true">
            Quick Triage
          </n-button>
        </div>
      </card>

      <card :noFooterLine="true" class="triaging-tiles" v-if="$store.state.erEncounter">
        <div class="col-12" style="padding: 0px;text-align: center;">
          <n-button type="primary" simple round @click.native="SHOW_CC=true">
            Vitals
          </n-button>
        </div>
      </card>

      <card :noFooterLine="true" class="triaging-tiles" v-if="$store.state.erEncounter">
        <div class="col-12" style="padding: 0px;text-align: center;">
          <n-button type="primary" simple round @click.native="SHOW_TRIAGE_ASSESSMENT=true">
            Treating Provider Assessment
          </n-button>
        </div>
      </card>

      <!--       <card :noFooterLine="true" class="triaging-tiles" v-if="$store.state.erEncounter">
        <div class="col-12" style="padding: 0px;text-align: center;">
          <n-button type="primary" simple round @click.native="SHOW_CONSENTS=true">
            Informed Consents
          </n-button>
        </div>
      </card> -->

      <!-- Consent -->
      <!--       <card v-if="SHOW_TRIAGE_FORM && !$store.state.erEncounter" id="consent-card">
        <div slot="header">
          <div class="row">
            <div class="col-12">
              <h4 slot="header" class="card-title">
                {{ $t("message.Informed Consent") }}
              </h4>
            </div>
          </div>
        </div>

        <p id="informed-consent" v-html="settings.erConsent"></p>

        <p>Signature</p>

      <vue-signature ref="signature" style="border: solid;" :sigOption="signaturePadOptions" :w="'225px'" :h="'140px'" :disabled="signaturePadDisabled"></vue-signature>
      <div class="col-12 text-center">
        <n-button type="primary" simple round @click.native="$refs.signature.clear()" v-if="!signed">
          <h6 class="m-0">
            {{ $t("message.Clear") }}
          </h6>
        </n-button>
        <n-button type="primary" round @click.native="onConsentAgreed()" v-if="!READY_TO_START && !SHOW_PAYMENT_GATEWAY">
          <h6 class="m-0">{{ $t("message.Agree") }}</h6>
        </n-button>

        <check-mark-svg v-if="READY_TO_START || SHOW_PAYMENT_GATEWAY"></check-mark-svg>
      </div>
      </card> -->

    </div>
    <div class="col-12" style="text-align:center" v-if="SHOW_TRIAGE_FORM && !$store.state.erEncounter">
      <n-button type="primary" round size="md" @click.native="createTriage">
        Create
      </n-button>
    </div>
    <div class="col-12" style="text-align:center" v-if="SHOW_TRIAGE_FORM && emergencyRoomEncounter && emergencyRoomEncounter._id">
      <n-button type="primary" round size="md" @click.native="completeAppointment">
        Mark As Complete
      </n-button>
    </div>
    <!-- changed close event to meaningful event -->
    <app-camera-scanner :showCam="SHOW_CAPTURE_MODAL" ref="camera" @onClose="SHOW_CAPTURE_MODAL = false" @idFound="idFound" @notFound="idNotFound">
    </app-camera-scanner>
  </div>
</template>

<script>
import InformedConsentService from "../../../services/informed-consents";
import AppCameraScanner from "../components/AppCameraScanner.vue";
export default {
  name: "emergency-triaging",
  components: {
    AppCameraScanner,
  },

  data() {
    return {
      signaturePadOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      signed: false,
      signaturePadDisabled: false,
      SHOW_CAPTURE_MODAL: false,
      mobileNumber: null,
      patients: [],
      patientSearchText: null,
      genderIconClass: "fa fa-users",
      doctorGenderFilter: "",
      ageUnit: "years",
      patientAge: null,
      patientAgeYears: null,
      patientAgeMonths: null,
      PATIENT_SELECTED: false,
      isValidMobile: false,
      NEW_PATIENT: false,
      SKIP_PATIENT: false,
      APPT_DETAILS_ENTERED: false,
      SHOW_DOCTOR_SELECTION_MODAL: false,
      READY_TO_START: false,
      SHOW_PAYMENT_GATEWAY: false,
      COUPON_CODE_APPLIED: false,
      couponCode: null,
      IS_COUPON_CODE_ERR: false,
      couponErrorMessage: "",
      patientProfileImage: null,
      createPatientBtnFixed: false,
      stepper: {
        completed: 0,
        total: 0,
      },
      SHOW_TRIAGE_FORM: false,

      // triaging info
      patientRegistration: {},
      emergencyRoomEncounter: {
        severity: 5,
        patient: {
          mobileNumber: "",
        },
        contactPerson: {
          phoneNumber: "",
          name: "",
          relation: "",
        },
        arrivalInfo: {
          date: "",
          arrivalMode: {
            ambulance: false,
            car: false,
            bike: false,
            publicTransport: false,
            walk: false,
            other: false,
          },
          priorFacilities: "",
          referedFrom: "",
        },
        vitals: {
          time: "",
          temperature: "",
          bpSystolic: "",
          bpDiastolic: "",
          pulse: "",
          spo2: "",
          rr: "",
        },
        triageCategory: {
          painScore: 0,
        },
        treatingProviderAssessment: {
          dateAndTime: "",
          deadOnArrival: false,
          highRiskSigns: {
            abnormalAVPU: false,
            hrInRange: false,
            temperatureInRange: false,
            spo2InRange: false,
            stridor: false,
            respiratoryDistress: false,
            poorPerfusion: false,
            vomitsEverything: false,
          },
          primarySurvey: {
            airWay: {
              normal: false,
              angioedema: false,
              stridor: false,
              voiceChanges: false,
              oralBurns: false,
              tongue: false,
              blood: false,
              secretions: false,
              vomit: false,
              foreignBody: false,
              repositioning: false,
              suction: false,
              OPA: false,
              NPA: false,
              LMA: false,
              BVM: false,
              ETT: false,
            },
            breathingNormal: false,
            breathing: {
              spontaneousRespiratoryRate: "",
              shallow: false,
              retractions: false,
              paradoxical: false,
              midline: false,
              deviatedToL: false,
              deviatedToR: false,
              breathSoundsL: false,
              breathSoundsR: false,
              oxygnQuant: "",
              NC: false,
              mask: false,
              NRB: false,
              BVM: false,
              CPAP_OR_BIPAP: false,
              ventilator: false,
              bronchodilator: false,
              chestNeedleL: false,
              chestNeedleLsize: "",
              chestNeedleLDepth: "",
              chestNeedleR: false,
              chestNeedleRSize: "",
              chestNeedleRDepth: "",
              threeSidedDressing: false,
            },
            circulationNormal: false,
            circulation: {
              CVL: false,
              warm: false,
              dry: false,
              pale: false,
              cyanotic: false,
              moist: false,
              cool: false,
              capilaryRefillBelowThree: false,
              capilaryRefillTime: "",
              weakPulse: false,
              asymetricPulse: false,
              jvd: false,
              jvdFalse: false,
              IV: false,
              IVLoc: "",
              IVSize: "",
              CLV: false,
              CLVLoc: "",
              CLVSize: "",
              IO: false,
              IOLoc: "",
              IOSize: "",
              IVF: false,
              IVFmls: "",
              NS: false,
              LR: false,
              other: false,
              otherDetails: "",
              bloodOrdered: false,
              epinephrineGiven: false,
            },
            disabilityNormal: false,
            disability: {
              A: false,
              V: false,
              P: false,
              U: false,
              movesAllExtremities: false,
              deflict: false,
              deflict_val: null,
              pupilSizeL: null,
              pupilSizeR: null,
              pupilReactivityL: null,
              pupilReactivityR: null,
              bloodGlucoseVal: null,
              glucose: false,
              naloxone: false,
              antiepileptic: false,
              OTHERS: false,
              otherDetails: "",
            },
          },
          historyOfIlness: "",
          reviewOfSystems: {
            generalNormal: false,
            general: "",
            HEENTNormal: false,
            HEENT: "",
            respNormal: false,
            resp: "",
            CVNormal: false,
            CV: "",
            GINormal: false,
            GI: "",
            pelvisNormal: false,
            pelvis: "",
            reproductiveNormal: false,
            reproductive: "",
            skinNormal: false,
            skin: "",
            mskNormal: false,
            msk: "",
            hemeNormal: false,
            heme: "",
            neuroNormal: false,
            neuro: "",
            psychiatricNormal: false,
            psychiatric: "",
          },
        },
      },
      SHOW_CC: false,
      SHOW_TRIAGE_ASSESSMENT: false,
      SHOW_TRIAGE_FORM_MODAL: false,
      SHOW_CONSENTS: false,
      SHOW_PATIENT_REGISTER_FORM: false,
      selectedConsent: { name: "" },
      consents: [],
      severity: -5,
    };
  },

  watch: {
    selectedConsent: function () {
      if (this.$refs.signature) {
        this.$refs.signature.clear();
      }
    },
    ageUnit: function () {
      console.log("calc DOB");
      this.calculateDob();
    },
    patientAge: function () {
      console.log("calcualating DOB");
      this.calculateDob();
    },
    severity: function () {
      this.emergencyRoomEncounter.severity = Math.abs(this.severity);
    },
  },

  beforeDestroy() {
    this.$store.commit("setState", {
      stateName: "erEncounter",
      stateValue: null,
    });
  },

  async mounted() {
    if (this.$store.state.erEncounter && this.$store.state.erEncounter._id) {
      this.emergencyRoomEncounter = this.$store.state.erEncounter;
      this.selectPatient(this.emergencyRoomEncounter.patient);
      this.consents = await this.$store.dispatch("getInformedConsents");
      if (this.consents && this.consents.length > 0) {
        this.selectedConsent = this.consents[0];
      }
      this.SHOW_TRIAGE_FORM = true;
    } else {
      this.emergencyRoomEncounter.arrivalInfo.date = new Date().toISOString();
    }
  },

  computed: {
    modelValidations() {
      return {
        firstName: {
          required: true,
        },
        lastName: {
          required: true,
        },
        email: {
          email: true,
        },
        gender: {
          required: true,
        },
        age: {
          required: true,
          min_value: 1,
          max_value: this.ageUnit == "years" ? 120 : 11,
        },
        reason: {
          required: true,
        },
      };
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    settings() {
      return this.$store.state.settings;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    isConsentSigned() {
      for (let consent of this.emergencyRoomEncounter.consents) {
        if (
          this.selectedConsent &&
          this.selectedConsent._id == consent.consentId
        ) {
          return true;
        }
      }
      return false;
    },
  },

  methods: {
    isPatientUnregistered(patient) {
      return patient.firstName == "unregistered";
    },
    initiatePatientRegistration() {
      this.patientAge = null;
      this.ageUnit = "years";
      this.SHOW_PATIENT_REGISTER_FORM = true;
      this.PATIENT_SELECTED = false;
    },
    async updateRegisteredPatient(patient) {
      this.selectPatient(patient);
      this.emergencyRoomEncounter = await this.$store.dispatch(
        "updateErPatient",
        this.emergencyRoomEncounter
      );

      this.SHOW_PATIENT_REGISTER_FORM = false;
      this.PATIENT_SELECTED = true;
    },
    registerPatient() {
      this.$validator.validateAll().then(async (isValid) => {
        if (isValid) {
          let patientDetails = {
            firstName: this.patientRegistration.firstName,
            lastName: this.patientRegistration.lastName,
            mobileNumber: this.patientRegistration.mobileNumber,
            dob: moment.utc(this.emergencyRoomEncounter.patient.dob),
            email: this.patientRegistration.email,
            history: this.patientRegistration.history,
            gender: this.patientRegistration.gender,
            additionalDetails: this.patientRegistration.additionalInfo,
          };

          let response = await this.$store.dispatch("registerPatientForER", {
            erEncounterId: this.emergencyRoomEncounter._id,
            patientDetails: patientDetails,
          });

          this.emergencyRoomEncounter = response;

          this.SHOW_PATIENT_REGISTER_FORM = false;
          this.PATIENT_SELECTED = true;
        }
      });
    },
    async skipPatientSelection() {
      this.SKIP_PATIENT = true;

      this.emergencyRoomEncounter.patient = {
        firstName: "unregistered",
        lastName: "patient",
      };
      this.PATIENT_SELECTED = true;
      this.SHOW_TRIAGE_FORM = true;
    },
    openCameraModal() {
      this.SHOW_CAPTURE_MODAL = true;
    },
    idNotFound() {
      if (this.SHOW_CAPTURE_MODAL) {
        this.SHOW_CAPTURE_MODAL = false;
        swal.fire({
          type: "error",
          title: "Error",
          text: "Id number not found!",
        });
      }
    },
    async idFound(id) {
      if (this.SHOW_CAPTURE_MODAL) {
        this.SHOW_CAPTURE_MODAL = false;
        console.log("ID -- ", id);
        try {
          let res = await this.$store.dispatch("getPatientByPatientId", id);
          if (res && res._id) {
            this.selectPatient(res);
          } else {
            swal.fire({
              type: "info",
              title: "Patient not found",
              text: `There is no patient with id : ${id}`,
            });
          }
        } catch (e) {
          console.log(e);
          swal.fire({
            type: "info",
            title: "Patient not found",
            text: `There is no patient with id : ${id}`,
          });
        }
      }
    },
    async agreeConsent() {
      if (!this.$refs.signature.isEmpty()) {
        let loader = this.$loading.show();
        InformedConsentService.getDataURL(
          this.$refs.signature.save("image/jpeg"),
          this.selectedConsent.delta,
          (dataUrl) => {
            fetch(dataUrl).then((res) => {
              res.blob().then(async (consent_blob) => {
                var d = new Date();
                var t = d.getTime();

                try {
                  let response = await this.$store.dispatch(
                    "getPresignedUrl",
                    "consent-" + t + ".pdf"
                  );
                  await this.$store.dispatch("saveFileToMinio", {
                    url: response.url,
                    file: consent_blob,
                  });

                  let fileDetails = {
                    type: "pdf",
                    fileId: response.fileId,
                  };

                  if (!this.emergencyRoomEncounter.consents) {
                    this.emergencyRoomEncounter.consents = [];
                  }
                  this.emergencyRoomEncounter.consents.push({
                    fileID: fileDetails.fileId,
                    consentId: this.selectedConsent._id,
                  });
                  this.emergencyRoomEncounter = await this.$store.dispatch(
                    "updateEmergencyRoomEncounter",
                    this.emergencyRoomEncounter
                  );
                  loader.hide();
                } catch {
                  loader.hide();
                  swal.fire({
                    type: "error",
                    title: this.$t("message.Error saving Disclaimer!"),
                    timer: 5000,
                  });
                }
              });
            });
          }
        );
      } else {
        swal.fire({
          type: "warning",
          title: "Signature is required!",
          timer: 3000,
        });
      }
    },
    async viewFile() {
      try {
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        let fileId = "";
        for (let consent of this.emergencyRoomEncounter.consents) {
          if (
            this.selectedConsent &&
            this.selectedConsent._id == consent.consentId
          ) {
            fileId = consent.fileID;
            break;
          }
        }
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch("getFile", fileId);

        let pdfBlob = new Blob([fileArrayBuffer]);

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              storageLocation = cordova.file.externalDataDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                fileId,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        loader.hide();
        console.log(e);
      }
    },
    async searchPatients(searchString) {
      try {
        if (searchString.length > 2) {
          this.patients = await this.$store.dispatch("searchPatients", {
            query: searchString,
            pageSize: 20,
          });
          if (this.patients.length > 0) {
            this.createPatientBtnFixed = true;
          }
        } else {
          this.patients = [];
          this.createPatientBtnFixed = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    selectPatient(patient) {
      this.patients = [];

      //Clear mobile number field
      this.emergencyRoomEncounter.patient.mobileNumber = "";
      this.emergencyRoomEncounter.patient.patientId = patient.patientId;
      this.emergencyRoomEncounter.patient.firstName = patient.firstName;
      this.emergencyRoomEncounter.patient.lastName = patient.lastName;

      if (patient.profileImage) {
        this.patientProfileImage = patient.profileImage;
      }

      var m = moment(patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAge = years;
      m = moment(m).add(years, "years");
      this.patientAgeMonths = moment().diff(m, "months", false);

      if (patient.gender == "female") {
        this.selectDoctorGender(patient.gender);
      }

      if (this.patientAgeYears < 1) {
        this.ageUnit = "months";
        this.patientAge = this.patientAgeMonths;
      } else {
        this.ageUnit = "years";
        this.patientAge = years;
      }

      this.emergencyRoomEncounter.patient.gender = patient.gender;
      this.emergencyRoomEncounter.patient.history = patient.history;
      this.emergencyRoomEncounter.patient.email = patient.email;
      this.emergencyRoomEncounter.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (this.emergencyRoomEncounter.patient.mobileNumber) {
        this.mobileNumber = this.emergencyRoomEncounter.patient.mobileNumber;
      }

      this.emergencyRoomEncounter.patient.additionalInfo =
        patient.additionalDetails ? patient.additionalDetails : {};
      this.emergencyRoomEncounter.patient.provider = patient.provider;
      this.addPatientEnable = false;
      if (this.error) this.error = "";
      this.PATIENT_SELECTED = true;
      this.SHOW_TRIAGE_FORM = true;
      this.createPatientBtnFixed = false;
    },
    mobileNumberUpdate(payload) {
      this.isValidMobile = payload.isValid;
      this.emergencyRoomEncounter.patient.mobileNumber =
        payload.formattedNumber;
    },
    calculateDob() {
      if (this.ageUnit == "years") {
        this.patientAgeMonths = null;
        this.patientAgeYears = this.patientAge;
      }

      if (this.ageUnit == "months") {
        this.patientAgeYears = null;
        this.patientAgeMonths = this.patientAge;
      }

      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.emergencyRoomEncounter.patient.dob =
        monthOfBirth + "/01/" + yearOFBirth;
    },
    resetPatientSelection() {
      this.emergencyRoomEncounter.patient = {
        mobileNumber: "",
      };
      this.PATIENT_SELECTED = false;
      this.SHOW_TRIAGE_FORM = false;
      this.NEW_PATIENT = false;
      this.SKIP_PATIENT = false;
      this.createPatientBtnFixed = true;
    },
    validateAppointmentDetails() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.APPT_DETAILS_ENTERED = true;

          setTimeout(() => {
            this.scrollTo("wrapper");
          }, 500);
        }
      });
    },
    validatePatientDetails() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.PATIENT_SELECTED = true;
          this.SHOW_TRIAGE_FORM = true;
          this.createPatientBtnFixed = false;
          this.SHOW_CONSENT = true;
        }
      });
    },
    async onConsentAgreed() {
      if (!this.$refs.signature.isEmpty()) {
        let loader = this.$loading.show();
        this.signed = true;
        this.signaturePadDisabled = !this.signaturePadDisabled;
        this.emergencyRoomEncounter.consent = {
          signedByOther: false,
        };

        ConsentService.getDataURL(
          this.$refs.signature.save("image/jpeg"),
          this.settings.erConsent,
          (dataUrl) => {
            fetch(dataUrl).then((res) => {
              res.blob().then(async (consent_blob) => {
                var d = new Date();
                var t = d.getTime();

                try {
                  let response = await this.$store.dispatch(
                    "getPresignedUrl",
                    "consent-" + t + ".pdf"
                  );
                  await this.$store.dispatch("saveFileToMinio", {
                    url: response.url,
                    file: consent_blob,
                  });

                  let fileDetails = {
                    type: "pdf",
                    fileId: response.fileId,
                  };

                  this.emergencyRoomEncounter.consent.fileID =
                    fileDetails.fileId;

                  try {
                    await this.setAppointmentDetails();
                    await this.createAppointment();
                    swal.fire({
                      type: "success",
                      title: "Triaging added",
                      timer: 3000,
                    });
                    loader.hide();
                    this.$router.push({ path: "/nursehome" });
                  } catch (error) {
                    loader.hide();
                    console.log(error);
                  }
                } catch {
                  loader.hide();
                  swal.fire({
                    type: "error",
                    title: this.$t("message.Error saving Disclaimer!"),
                    timer: 5000,
                  });
                }
              });
            });
          }
        );
      } else {
        swal.fire({
          type: "warning",
          title: "Signature is required!",
          timer: 3000,
        });
      }
    },
    async setAppointmentDetails() {
      this.emergencyRoomEncounter.status = [
        {
          status: "Created",
          timestamp: new Date().getTime(),
        },
      ];
      this.emergencyRoomEncounter.latestStatus = "Created";

      this.emergencyRoomEncounter.createdBy = "nurse";

      if (this.emergencyRoomEncounter.patient.dob)
        this.emergencyRoomEncounter.patient.dob = moment.utc(
          this.emergencyRoomEncounter.patient.dob
        );
      //this.emergencyRoomEncounter.startTime = "";

      this.emergencyRoomEncounter.endpoint = this.endpoint.name;
    },
    async createTriage() {
      try {
        await this.setAppointmentDetails();
        await this.createAppointment();
        swal.fire({
          type: "success",
          title: "Triaging added",
          timer: 3000,
        });
        this.$router.push({ path: "/nursehome" });
      } catch (error) {
        console.log(error);
      }
    },
    async createAppointment() {
      try {
        if (this.SKIP_PATIENT) {
          // creating unrejistered patient
          let patient = {
            firstName: this.emergencyRoomEncounter.patient.firstName,
            lastName: this.emergencyRoomEncounter.patient.lastName,
            roles: ["patient"],
          };
          let response = await this.$store.dispatch("createPatient", patient);

          this.emergencyRoomEncounter.patient.patientId = response.patientId;
        }
        if (this.NEW_PATIENT) {
          let patient = {
            firstName: this.emergencyRoomEncounter.patient.firstName,
            lastName: this.emergencyRoomEncounter.patient.lastName,
            mobileNumber: this.emergencyRoomEncounter.patient.mobileNumber,
            roles: ["patient"],
            dob: moment.utc(this.emergencyRoomEncounter.patient.dob),
            email: this.emergencyRoomEncounter.patient.email,
            password: moment(this.emergencyRoomEncounter.patient.dob).format(
              "ddMMyyyy"
            ),
            history: this.emergencyRoomEncounter.patient.history,
            gender: this.emergencyRoomEncounter.patient.gender,
            additionalDetails:
              this.emergencyRoomEncounter.patient.additionalInfo,
          };

          let response = await this.$store.dispatch("createPatient", patient);

          this.emergencyRoomEncounter.patient.patientId = response.patientId;
        }
        //Update existing encounter if already created
        if (this.emergencyRoomEncounter && this.emergencyRoomEncounter._id) {
          this.emergencyRoomEncounter = await this.$store.dispatch(
            "updateEmergencyRoomEncounter",
            this.emergencyRoomEncounter
          );
        } else {
          this.emergencyRoomEncounter = await this.$store.dispatch(
            "createEmergencyRoomEncounter",
            this.emergencyRoomEncounter
          );
        }

        return this.emergencyRoomEncounter;
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async save() {
      try {
        this.emergencyRoomEncounter = await this.$store.dispatch(
          "updateEmergencyRoomEncounter",
          this.emergencyRoomEncounter
        );
        swal.fire({
          type: "success",
          title: "Changes saved!",
          timer: 3000,
        });
      } catch (e) {
        console.log(e);
        swal.fire({
          type: "error",
          text: "Couldn't save changes!",
          title: "Error",
          timer: 3000,
        });
      }
    },
    completeAppointment() {
      swal
        .fire({
          title: "Marking this encounter as completed",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          closeOnConfirm: true,
        })
        .then(async (confirm) => {
          if (confirm.value) {
            try {
              await this.$store.dispatch("updateErEncounterStatus", {
                emergencyRoomEncounterId: this.emergencyRoomEncounter._id,
                status: "Completed",
              });
              swal.fire({
                type: "success",
                title: "Success",
                timer: 3000,
              });
              this.$router.push({ path: "/nursehome" });
            } catch (e) {
              console.log(e);
              swal.fire({
                type: "error",
                title: "Error",
                text: "Couldn't mark this encounter as completed",
                timer: 3000,
              });
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}
/deep/.triaging-tiles .card-body {
  padding: 15px;
}
/deep/ .consents-dropdown .dropdown {
  width: 100%;
  border: #0000008c solid 0.5px;
  border-radius: 2em;
}
/deep/.consents-dropdown .nav-link {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
